import { Link } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthForgotPassword from 'sections/auth/auth-forms/AuthForgotPassword';

// ================================|| FORGOT PASSWORD ||================================ //

const ForgotPassword = () => {
    const { isLoggedIn } = useAuth();

    return (
        <AuthWrapper>
            <div className="flex flex-col gap-6">
                <div className="-mb-1 flex items-baseline justify-between sm:mb-1">
                    <h3 className="text-h3 text-balance">Forgot Password</h3>
                    <Link to={isLoggedIn ? '/auth/login' : '/login'} className="text-body1 text-primary no-underline">
                        Back to Login
                    </Link>
                </div>
                <AuthForgotPassword />
            </div>
        </AuthWrapper>
    );
};

export default ForgotPassword;
